<!--单位信息模块-->
<template>
	<div class="yige_unitInfoBody">
		<div class="topLeftTitleContent">
			<span>{{nowUnit.fullName}}</span>
		</div>
		<div class="unitContent bodyBorder" style="display: flex;align-items: center;justify-content: space-between;">
			<div class="yige_Intr">
				<p>系统简介</p>
				<p>
				  {{nowUnit.memo}}
				</p>
			</div>
			<div class="yige_img_container">
				<img src="../../../../public/static/image/projectImg/yige/unitInfo.png" />
			</div>
		</div>
	</div>
</template>
<script>
	import columnsContent from '@/page/unitKanBan/component/columnsContent.vue'
	export default {
		components: {
			columnsContent,
		},
		props: [],
		data() {
			return {
				kanbanCountInfo: {
					device: 0,
					monitoringPoint: 0,
					user: 0,
				}
			}
		},
		created() {},
		mounted() {
		},
		destroyed() {},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			showExport() {
				//看看是不是应该显示导出运维报告
				return this.$router.currentRoute.path != '/temperatureOverView'
			},
			getBackgroudImageStyle() {
				return this.$store.resourcesStore.getters.getBackgroudImageStyle
			},
			getResourcesByName() {
				return this.$store.resourcesStore.getters.getResourcesByName
			},
		},
		watch: {
		},
		methods: {
			exportReport() {
				this.$dialogMethod.showLoading("正在生成报告。。。")
				this.$api.reportApi.exportUnitMonthReportWord(this.nowUnit.id, new Date(new Date().formatByMonth()).getTime() - 24 *
					60 *
					60 * 1000, respon => {
						if(!respon.includes('%2F')) {
							this.$dialogMethod.showMessage(respon)
							return
						}
						saveAs(DWSystemSetting.downloadUrl + '/' + respon, respon.substring(respon.lastIndexOf('%2F') + 3))
						this.$dialogMethod.closeLoading()
					})
			},
		}
	}
</script>

<style scoped>
	@import url("../../../components/css/usePowerUnit.css");
	.yige_unitInfoBody {
		height: 274px;
	}
	.yige_unitInfoBody .topLeftTitleContent{
	     display:flex;
	     align-items: center;
	     justify-content: center;	
	}
	.yige_unitInfoBody .topLeftTitleContent span{
	   font-size: .18rem;
	}
	.columnsContent {
		margin: 20px 10px;
	}
	
	.unitContent {
		height: calc(100% - 31px);
		overflow: hidden;
	}
	
	.userInfo {
		width: 45%;
		height: 60%;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}
	
	.userInfo div {
		display: flex;
		align-items: center;
		flex-direction: column;
		height: 70%;
		justify-content: space-around;
	}
	
	.userInfo div p {
		width: 100%;
		height: 5px;
	}
	
	.userInfo div span {
		font-size: .3rem;
	}
	
	.userInfo div:nth-child(1) span {
		color: #86e4f5;
	}
	
	.userInfo div:nth-child(1) p {
		background-color: #86e4f5;
	}
	
	.userInfo div:nth-child(2) span {
		color: #ff9900;
	}
	
	.userInfo div:nth-child(2) p {
		background-color: #ff9900;
	}
	
	.userInfo div:nth-child(3) span {
		color: #0293fc;
	}
	
	.userInfo div:nth-child(3) p {
		background-color: #0293fc;
	}
	.yige_Intr{
		width: 35%;
		height: 100%;
	}
	.yige_Intr p{
		margin-left: 5%;
	}
	.yige_Intr p:nth-child(1){
		margin-top:5% ;
	}
	.yige_img_container{
		width: 65%;
		height: 100%;
		display: flex;
		    flex-direction: column;
		align-content: center;
		justify-content: center;
	}
	.yige_img_container img{
		width: 100%;
		height: 80%;
	}
</style>